module.exports = __webpack_public_path__ + "img/end-contract.829136d0.svg";